import { queryOptions } from '@tanstack/react-query'
import { nanoid } from 'nanoid'
import { getMapDeployments } from '@/features/filteredMap/mapDeployments/getMapDeployments'
import type {
	FilterGroup,
	MapFilter,
} from '../filteredMap/filters/models/models'
import {
	normaliseCountryCode,
	normaliseMarketName,
} from '../filteredMap/mapDeployments/utils'
// import marketviewAssetsDemand from './data/marketview-assets-demand.json'
import {
	type DemandMapDeployment,
	validateServerReceivedDemandMapDeployment,
} from './models/demandSchema'

export const demandMapDeploymentsQueryOptions = queryOptions({
	queryKey: ['demandMapDeployments'],
	queryFn: async () =>
		getMapDeployments<DemandMapDeployment>({
			localStorageKey: 'ogw_marketview-demand-deployments',
			remoteUrl:
				'https://d3bj8knxlstxyw.cloudfront.net/marketview-assets-demand.json',
			publicFolderUrl: '/json/marketview-assets-demand.json',
			validationFunction: validateServerReceivedDemandMapDeployment,
		}),
	staleTime: 1000 * 60 * 60, // 1 hour
})

export function createInitialDemandFilterGroups(data: DemandMapDeployment[]): {
	filterGroups: FilterGroup[]
	initialData: DemandMapDeployment[]
} {
	// allows you to easily change the filter display name without affecting the filter logic,
	// as the logic relies on the 'name' property which should match the property names in the data
	const filterList = [
		{ name: 'organisation', displayName: 'Enterprise' },
		{ name: 'sector', displayName: 'Sectors' },
		{ name: 'region', displayName: 'Regions' },
		{ name: 'market', displayName: 'Markets' },
		{ name: 'api', displayName: 'API Demands' },
	] as const

	const filterGroups: FilterGroup[] = filterList.map((filterName, index) => ({
		id: nanoid(),
		name: filterName.name,
		displayName: filterName.displayName,
		order: index,
		filters: [],
		dataType: 'string',
	}))
	const normalisedData = data.map((deployment) => ({
		...deployment,
		market: normaliseMarketName(deployment.market),
		countryCode: normaliseCountryCode(deployment.countryCode),
		api: deployment.api.replaceAll('-', ' '), // replace - with space for better readability
	}))

	normalisedData.forEach((deployment) => {
		filterGroups.forEach((group) => {
			const value = deployment[
				group.name as keyof DemandMapDeployment
			] as string
			// check if value already exists in filters, if not add it
			if (
				!group.filters.some(
					(f) => f.name === value.replaceAll('-', ' ')
				)
			) {
				group.filters.push({
					id: nanoid(),
					name: value.replaceAll('-', ' '), // replace - with space for better readability
					isSelected: false,
					isSelectable: true,
					type: 'checkbox',
				} as MapFilter)
			}
			// sort filters alphabetically
			group.filters = group.filters.toSorted((a, b) =>
				a.name.localeCompare(b.name)
			)
		})
	})

	return { filterGroups, initialData: normalisedData }
}
// export function initialiseDemandData() {
// 	const initialData =
// 		marketviewAssetsDemand.deployments as DemandMapDeployment[]
// 	const filterGroups = createInitialDemandFilterGroups(initialData)
// 	return { initialData, filterGroups }
// }

// function main() {
// 	const filterGroups = createInitialFilterGroups(
// 		marketviewAssetsDemand.deployments as DemandMapDeployment[]
// 	)
// 	console.log(JSON.stringify(filterGroups, null, 2))
// }

// main()
